import { useActions, useStore } from 'vuex-composition-helpers';
import { FilerProductType } from '@ve/components/hotel/filters/common/store/types';
import { getCurrentInstance } from 'vue';

const filtersMappingStoreName = 'mapForFilters';
const datesTabsModuleName = 'mapForDatesTabs';

export default () => {
    const proxy = getCurrentInstance()?.proxy;

    const {
        selectDateManually,
    } = useActions(datesTabsModuleName, ['selectDateManually']);

    const {
        action_isExclusive: setIsExclusive,
        action_productType: setProductType,
        action_operators: setOperators,
    } = useActions(filtersMappingStoreName, ['action_isExclusive', 'action_productType', 'action_operators']);

    const selectProductTypeFilter = (filerProductType: FilerProductType) => {
        selectDateManually();
        setProductType(filerProductType);
    };

    const selectOperatorFilter = (operators: number[]) => {
        setOperators(operators);
    };

    const changeIsExclusiveFilter = (isExclusive: boolean) => {
        setIsExclusive(isExclusive);
    };

    const selectMealsFilter = (meals: number[]) => {
        proxy?.$root.$emit('meal-filter-changed', meals);
    };

    const changeWarrantedFilter = (warranted: boolean) => {
        proxy?.$root.$emit('warranted-filter-changed', warranted);
    };

    return {
        selectMealsFilter,
        selectProductTypeFilter,
        selectOperatorFilter,
        changeIsExclusiveFilter,
        changeWarrantedFilter,
    };
};